
  /**
   * center 模块 ParamTrackerCtrl 
   */
  const trackLogInfo = state =>state.trackLogInfo||{};

  const trackLogStatus = state =>state.trackLogStatus||'';
const status = state => {
    return (state && state.status) || ''
}
const loading = state => {
    return state.loading || 'loading'
}
const userInfo = state => {
    return state.userInfo || {}
}
const drLoading = state => {
    return state.drLoading || 'loading'
}
const userDrInfo = state => {
    return state.userDrInfo || {}
}

const curGearInfo = state => {
    return state.curGearInfo || {}
}
const cgLoading = state => {
    return state.cgLoading || ''
}

const payModeInfo = state => {
    return state.payModeInfo || {}
}
const pmLoading = state => {
    return state.pmLoading || ''
}

const iapInfo = state => {
    return state.iapInfo || {}
}
const iapLoading = state => {
    return state.iapLoading || ''
}

const orderInfo = state => {
    return state.orderInfo || {}
}
const orderLoading = state => {
    return state.orderLoading || ''
}

const orderData = state => {
    return state.orderData || {}
}
const orderStatus = state => {
    return state.orderStatus || ''
}

const orderVerifyData = state => {
    return state.orderVerifyData || {}
}
const ovStatus = state => {
    return state.ovStatus || ''
}

const reqData = state => {
    return state.reqData || {}
}
const reqStatus = state => {
    return state.reqStatus || ''
}

const goodsDetail = state => {
    return state.goodsDetail || {}
}
const gdLoading = state => {
    return state.gdLoading || ''
}

const dpList = state => {
    return state.dpList || {}
}
const dpLoading = state => {
    return state.dpLoading || ''
}

const cRoleList = state => {
    return state.cRoleList || {}
}
const crLoading = state => {
    return state.crLoading || ''
}

const subList = state => {
    return state.subList || {}
}
const subLoading = state => {
    return state.subLoading || ''
}

const pointData = state => {
    return state.pointData || {}
}
const upLoading = state => {
    return state.upLoading || ''
}

const pointRule = state => {
    return state.pointRule || {}
}
const urLoading = state => {
    return state.urLoading || ''
}

const pointSwitch = state => {
    return state.pointSwitch || {}
}
const uwLoading = state => {
    return state.uwLoading || ''
}

const codeData = state => {
    return state.codeData || {}
}
const codeStatus = state => {
    return state.codeStatus || ''
}

const setEmailData = state => {
    return state.setEmailData || {}
}
const seStatus = state => {
    return state.seStatus || ''
}

const pointInit = state => {
    return state.pointInit || {}
}
const piLoading = state => {
    return state.piLoading || ''
}

const pwdFlag = state => {
    return state.pwdFlag || {}
}
const pfLoading = state => {
    return state.pfLoading || ''
}

const emailFlag = state => {
    return state.emailFlag || {}
}
const efLoading = state => {
    return state.efLoading || ''
}

const pwdData = state => {
    return state.pwdData || {}
}
const psStatus = state => {
    return state.psStatus || ''
}

const cPwdData = state => {
    return state.cPwdData || {}
}
const cpStatus = state => {
    return state.cpStatus || ''
}

const peData = state => {
    return state.peData || {}
}
const peStatus = state => {
    return state.peStatus || ''
}

const checkData = state => {
    return state.checkData || {}
}
const checkStatus = state => {
    return state.checkStatus || ''
}

const cpeData = state => {
    return state.cpeData || {}
}
const cpeLoading = state => {
    return state.cpeLoading || ''
}

const checkUPData = state => {
    return state.checkUPData || {}
}
const checkUPStatus = state => {
    return state.checkUPStatus || ''
}

const versionData = state => {
    return state.versionData || {}
}
const vLoading = state => {
    return state.vLoading || ''
}
const showPage = state => {
    return state.showPage
}

export default {
    status,
    drLoading,
    userDrInfo,
    loading,
    checkUPData,
    checkUPStatus,
    cpeData,
    cpeLoading,
    peData,
    peStatus,
    checkData,
    checkStatus,
    pointData,
    upLoading,
    pointRule,
    urLoading,
    pointSwitch,
    uwLoading,
    codeData,
    codeStatus,
    setEmailData,
    seStatus,
    pointInit,
    piLoading,
    pwdFlag,
    pfLoading,
    emailFlag,
    efLoading,
    pwdData,
    psStatus,
    cPwdData,
    cpStatus,
    subList,
    subLoading,
    cRoleList,
    crLoading,
    dpList,
    dpLoading,
    userInfo,
    curGearInfo,
    cgLoading,
    payModeInfo,
    pmLoading,
    iapInfo,
    iapLoading,
    orderInfo,
    orderLoading,
    orderData,
    orderStatus,
    orderVerifyData,
    ovStatus,
    reqData,
    reqStatus,
    goodsDetail,
    gdLoading,
    versionData,
    vLoading,
    showPage,
    // center 模块 ParamTrackerCtrl 
    trackLogInfo,
    trackLogStatus,
}